// extracted by mini-css-extract-plugin
export default {"button":"ForwarderOfferDetailsSection_button__RqcAM"};